module.exports = __webpack_public_path__ + "media/application/images/twitter-c2ee9de1351720762975911e6bd62cd4.svg";